import React, { useState } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData } from "hooks/useApiHooks";
import { formatNumber, unformatNumber } from "utils/utils";

        
const CreatePageAddStock = ({ initialData, onSuccess, onError,suppliers }) => {
  const API_URL = "/menu";

  const [formData, setFormData] = useState({
    supplier_id: "",
    stock: "",
    note: "",
  });

  const { createData } = useCreateData(
    `${API_URL}/${initialData?.id}/stock`, // ✅ POST to /menu/{id}/stock
    "menus"
  );

  const handleChange = useFormChangeHandler(setFormData);

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    createData,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      stock: unformatNumber(formData.stock), // Unformat stock value before sending
    };

    handleSubmit(payload, e);
  };

  // Format value when focus is lost
    const handleBlur = () => {
      if (formData.stock) {
        const formattedValue = formatNumber(formData.stock); // Format using utils
        setFormData({
          ...formData,
          stock: formattedValue,
        });
      }
    };
  
    // Convert formatted value back to number on focus
    const handleFocus = () => {
      const rawValue = unformatNumber(formData.stock); // Unformat using utils
      setFormData({
        ...formData,
        stock: rawValue,
      });
    };

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}

      <div className="action-sheet-content flex-grow-1">
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Add:
          </label>
          {/* <div className="col-sm-8">
            <input
              type="number"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.stock && "is-invalid"
              )}
              id="stock"
              placeholder="Add stock"
              name="stock"
              value={formData.stock}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              min={1}
            />
            {formError?.stock && (
              <div className="invalid-feedback">{formError.stock}</div>
            )}
          </div> */}
          <div className="col-sm-8">
            <input
              type="text" // Menggunakan type text karena kita ingin menambahkan format ribuan
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.stock && "is-invalid"
              )}
              id="stock"
              placeholder="Add stock"
              name="stock"
              value={formData.stock}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              // minLength={3}
            />
            {formError?.stock && (
              <div className="invalid-feedback">{formError.stock}</div>
            )}
          </div>
        </div>
        {/* select supplier */}
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Supplier:
          </label>
          <div className="col-sm-8">
            <select
              className={clsx(
                "form-select gotra-form-control rounded-1",
                formError?.supplier_id && "is-invalid"
              )}
              id="supplier_id"
              name="supplier_id"
              value={formData.supplier_id}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            >
              <option value="">Select Supplier</option>
              {suppliers.map((supplier) => (
                <option key={supplier.id} value={supplier.id}>
                  {supplier.name}
                </option>
              ))}
            </select>
            {formError?.supplier_id && (
              <div className="invalid-feedback">{formError.supplier_id}</div>
            )}
          </div>
        </div>
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Note:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.note && "is-invalid"
              )}
              id="note"
              placeholder="Note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.note && (
              <div className="invalid-feedback">{formError.note}</div>
            )}
          </div>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          Add Stock
        </button>
      </div>
    </form>
  );
};

export default CreatePageAddStock;
